import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { lastValueFrom } from "rxjs";
import { ScoreService } from "./score.service";
import { FormulasService } from "./formulas.service";
import { MedicalToolService } from "./medical-tool.service";
import { MedicalTool } from "../entities/tools/medical-tool";
import { ToolViewerModalComponent } from "../modules/modals/tool-viewer-modal/tool-viewer-modal.component";
import { ScaleService } from "../modules/tools/scale/scale.service";
import { ScaleViewerComponent } from "../modules/tools/scale/scale-viewer/scale-viewer.component";
import { MedicalToolViewerDialogComponent } from "../modules/tools/medical-tools-dashboard/medical-tool-viewer-dialog/medical-tool-viewer-dialog.component";

@Injectable({
	providedIn: "root",
})
export class ToolViewerService {
	private dialog = inject(MatDialog);
	private scoreService = inject(ScoreService);
	private formulasService = inject(FormulasService);
	private scaleService = inject(ScaleService);
	private medicalToolService = inject(MedicalToolService);

	async openScore(id: number): Promise<void> {
		const scores = await lastValueFrom(this.scoreService.getScores());
		const item = scores.find((s) => s.id === id);
		if (!item) return;

		this.dialog.open(ToolViewerModalComponent, {
			data: { type: "score", item },
			width: "600px",
			maxHeight: "90vh",
			autoFocus: false,
		});
	}

	async openFormula(id: number): Promise<void> {
		const formulas = await lastValueFrom(this.formulasService.getFormulas());
		const item = formulas.find((f) => f.id === id);
		if (!item) return;

		this.dialog.open(ToolViewerModalComponent, {
			data: { type: "formula", item },
			width: "500px",
			maxHeight: "90vh",
			autoFocus: false,
		});
	}

	async openScale(id: number): Promise<void> {
		const scales = await lastValueFrom(this.scaleService.getScales());
		const scale = scales.find((s) => s.id === id);
		if (!scale) return;

		this.dialog.open(ScaleViewerComponent, {
			data: { scale },
			width: "800px",
			maxWidth: "95vw",
			maxHeight: "90vh",
			autoFocus: false,
		});
	}

	async openMedicalTool(id: number): Promise<void> {
		let tool: MedicalTool;
		try {
			tool = await lastValueFrom(this.medicalToolService.getOne(id));
		} catch {
			return;
		}
		if (!tool) return;

		this.dialog.open(MedicalToolViewerDialogComponent, {
			data: tool,
			width: "900px",
			maxWidth: "95vw",
			maxHeight: "90vh",
			autoFocus: false,
		});
	}
}
